// vuex
import { mapState, mapMutations } from 'vuex';
import eecMixin from '~/components/pages/international/common/international-eec';
// lodash utils
import isEmpty from 'lodash/isEmpty';

export default {
    mixins: [
        eecMixin,
    ],
    data () {
        return {
            numbers: ['اول', 'دوم', 'سوم', 'چهارم', 'پنجم'],
        };
    },
    computed: {
        ...mapState('international', ['selectedPackage']),

        isMultiDestination () {
            return this.type === 'multiCity';
        },
    },
    methods: {
        ...mapMutations('international', ['setPackage', 'indicateCallCancel', 'setIsCompleted']),
        flightData (data) {
            let text = data.adult + data.child + data.infant;
            text += ' مسافر';
            switch (data.flightClass) {
            case 'economy':
                text += '، اکونومی';
                break;
            case 'business':
                text += '، بیزنس';
                break;
            case 'first':
                text += '، فرست';
                break;
            default:
                break;
            }
            return text;
        },
        defaultLogoGray ({ target }) {
            if (target) {
                target.onerror = '';
                target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8WA8AAkcBYnr93DQAAAAASUVORK5CYII=';
            }
        },
        defaultLogo ({ target }) {
            if (target) {
                target.onerror = '';
                target.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D';
            }
        },
        isCodeShare (flight) {
            return flight.marketingCarrier !== flight.operatingCarrier &&
                flight.marketingCarrierName !== flight.airlineName;
        },
        getIndexName (index) {
            return this.numbers[index];
        },
        isCity (option) {
            return option && (option.domainCode || '').length > 3;
        },
        // cancel depart selected and then set the original departing array into store and try again for selecting new available into store
        cancelAvailable () {
            new Promise((resolve) => {
            // call mutation for cancel package
                this.indicateCallCancel(true);
                this.setIsCompleted(true);
                this.setPackage({});
                // send remove from cart data to GTM
                this._$if__removeFromCart();
                const result = this.$emit('cancel-package');
                resolve(result);
            }).then(() => {
                this.$router.push({
                    query: { ...this.$router.currentRoute.query, ...{ step: 'results' } },
                });
            });
        },
        // Check the User has selected package or No
        existPackage () {
            return !isEmpty(this.selectedPackage);
        },
        getTooltipOptions (options) {
            options = Object.assign(
                {
                    content: '',
                    placement: 'top',
                    classes: ['tooltip--blue-wood font-13'],
                    trigger: 'click hover',
                },
                options
            );
            return options;
        },
    },
};
